import { Product } from "./Product";

export class Order{
    public OrderID?:number;
    public FirstName!: string;
    public LastName!: string;
    public MobilePhoneNumber!: string;
    public Address!: string;
    public Landmark!: string;
    public Product!: Product;
    public VoucherCode!:string;
    public DiscountVoucherID!:number;
    public StoreID!:number;
    public Discount!:number;
    public Quantity:number = 1;
    public Total!:number;

    constructor(init?:Partial<Order>){
        Object.assign(this, init);
    }
}

